import { Component, NgZone } from "@angular/core";
import {
  NavController,
  PopoverController,
  Platform,
  ModalController
} from "ionic-angular";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { APIServiceProvider } from "./../../common/services/api.service";
import { NotificationsService } from "./../../common/services/notifications/notifications.service";
import { LocationTracker } from "./../../common/services/location-tracker";
import { NotifyService } from "../../services/notify.service";
import { UserService } from "../../services/user.service";

import { Market } from "@ionic-native/market";

import { AppVersion } from "@ionic-native/app-version";

import { MapPage } from "./../map/map";

import { TabOrder } from "./../orders/tabs/tab-order";
import { DepoModalPage } from "./../../modals/depo/depo.modal";

import { TabInventory } from "./../inventory/tabs/tab-inventory";
import { TabSettlement } from "./../settlement/tabs/tab-settlement";
import { NotificationPage } from "./../notification/notification";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  stats: any = {
    orders_amount_of_not_settled_txns: 0,
    orders_with_pending_payment_amount: 0,
    approval: 0,
    dispatched: 0,
    received: 0,
    stock_transfer: 0,
    total_not_settled_amount_delivered:0,
		total_not_settled_amount_prepaid:0,
		total_pending_amount_delivered:0,
		total_pending_amount_prepaid:0,

    collection_pending_delivered:0,
		settlement_pending_delivered:0,
		collection_pending_dispatched:0,
		settlement_pending_dispatched:0,
		collection_pending_received:0,
		settlement_pending_received:0

  };

  constructor(
    private locationTracker: LocationTracker,
    public nav: NavController,
    public zone: NgZone,
    public helperService: HelperServiceProvider,
    public apiService: APIServiceProvider,
    public modalController: ModalController,
    private appVersion: AppVersion,
    public platform: Platform,
    private market: Market,
    public notificationsService: NotificationsService,
    public userService: UserService,
    public popoverCtrl: PopoverController,
    private notifyService: NotifyService
  ) {}

  checkAppVersion() {
    let self = this;

    this.appVersion.getVersionNumber().then(function(version) {
      let postData: any = {};

      postData.app_version = version;

      self.apiService
        .post("auth/fieldapp/check-version", postData)
        .subscribe(result => {
          var force_update = result["force_update"];
          var soft_update = result["soft_update"];

          if (force_update) {
            self.forceUpdate();

            //Do the force update related action
            return true;
          }

          if (soft_update) {
            self.forceUpdate();
            //Do the soft update related action
            return true;
          }
        });
    });
  }

  forceUpdate() {
    try {
      this.market.open("in.gramophone.fieldapp");
    } catch (err) {
      this.helperService.presentToast(
        "Please the access not able to open field app in play store"
      );
    }
  }

  getUserPosition() {}

  doRefresh(refresher) {
    this.loadStats(true, refresher);
    localStorage.setItem("manager_user_id", localStorage.getItem("user-id"));
  }

  ionViewDidLoad() {
    localStorage.setItem("manager_user_id", localStorage.getItem("user-id"));

    if (this.platform.is("cordova")) {
      this.locationTracker.startTracking();

      this.zone.run(() => {
        this.helperService.user_img = localStorage.getItem("gp_img");
      });
    }

    this.notifyService.updateDashboard.subscribe(() => {
      this.loadStats(false);
    });

    this.notifyService.cashSubmitted.subscribe(() => {
      this.loadStats(false);
    });

    this.notifyService.orderPlaced.subscribe(() => {
      this.loadStats(false);
    });

    this.notifyService.orderDelivered.subscribe(() => {
      this.loadStats(false);
    });

    this.notifyService.orderModified.subscribe(() => {
      this.loadStats(false);
    });

    this.loadStats(false);

    //this.locationTracker.startTracking();

    this.userService.checkForSubordinates();
  }

  resetUserInfo() {
    localStorage.setItem("manager_user_id", localStorage.getItem("user-id"));
  }

  gotoSettlementPending() {
    let self = this;

    this.resetUserInfo();

    this.nav.push(TabSettlement);

    setTimeout(function() {
      self.nav.getActiveChildNav().select(1);
    }, 100);
  }

  goToMap() {
    this.nav.push(MapPage);
  }
  goToNotification() {
    this.nav.push(NotificationPage);
  }

  goToDelivered() {
    let self = this;

    this.resetUserInfo();

    this.nav.push(TabOrder);

    setTimeout(function() {
      self.nav.getActiveChildNav().select(3);
    }, 100);
  }

  toDo() {
    this.helperService.presentToast("Feature is yet to be done!");
  }

  goToStockTransfer() {
    let self = this;

    this.resetUserInfo();

    this.nav.push(TabInventory);

    setTimeout(function() {
      self.nav.getActiveChildNav().select(1);
    }, 100);
  }

  goToDispatched() {
    let self = this;

    this.resetUserInfo();

    this.nav.push(TabOrder);

    setTimeout(function() {
      self.nav.getActiveChildNav().select(1);
    }, 100);
  }

  goToRecieved() {
    let self = this;

    this.resetUserInfo();

    this.nav.push(TabOrder);

    setTimeout(function() {
      self.nav.getActiveChildNav().select(2);
    }, 100);
  }

  openSelectedtDepo() {
    let modalObject: any = {};

    modalObject = this.modalController.create(DepoModalPage, {
      index: null,
      product_id: null,
      type: "defaultdepo"
    });

    modalObject.present();
  }

  loadStats(refresh: boolean, refreshObj?) {
    this.apiService.post("dashboard/stats", {}).subscribe(response => {
      this.stats.orders_amount_of_not_settled_txns = response["data"]["orders_amount_of_not_settled_txns"];
      this.stats.orders_with_pending_payment_amount = response["data"]["orders_with_pending_payment_amount"]; 
      this.stats.approval = response["data"]["approval"];
      this.stats.dispatched = response["data"]["dispatched"];
      this.stats.received = response["data"]["received"];
      this.stats.stock_transfer = response["data"]["stock_transfer"];

      this.stats.total_not_settled_amount_delivered = response["data"]["total_not_settled_amount_delivered"];
 			this.stats.total_not_settled_amount_prepaid = response["data"]["total_not_settled_amount_prepaid"];
 			this.stats.total_pending_amount_delivered = response["data"]["total_pending_amount_delivered"];
 			this.stats.total_pending_amount_prepaid = response["data"]["total_pending_amount_prepaid"];



       this.stats.collection_pending_delivered = response["data"]["collection_pending_delivered"];
       this.stats.settlement_pending_delivered = response["data"]["settlement_pending_delivered"];
       this.stats.collection_pending_dispatched =response["data"]["collection_pending_dispatched"];
       this.stats.settlement_pending_dispatched = response["data"]["settlement_pending_dispatched"];
       this.stats.collection_pending_received= response["data"]["collection_pending_received"];
       this.stats.settlement_pending_received=response["data"]["settlement_pending_received"];
       
      if (refresh) {
        refreshObj.complete();
      }
    });
  }
}

//



// WEBPACK FOOTER //
// ./src/pages/home/home.ts